import PopularTripBooking from './PopularTripBooking';

export default PopularTripBooking;